import {GlobalVariables} from "../GlobalVariables";

export default class Sidebar {
	static init() {

		let sidebar = document.querySelector('.sidebar');
		sidebar.addEventListener('mouseenter', () => {
			!GlobalVariables.isMobile && GlobalVariables.smoother.paused(true);
		});
		sidebar.addEventListener('mouseleave', () => {
			!GlobalVariables.isMobile && GlobalVariables.smoother.paused(false);
		});
	}
}
